import { authService } from "@/services/credential/auth-service";
import { create } from "zustand";
import { UserAuthMe } from "../services/credential/user";

interface AuthState {
  isAuthenticated: boolean;
  user: UserAuthMe | null;
  setUser: (user?: UserAuthMe) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => {
  const user = authService.checkLogin();
  const isAuthenticated = user !== null;

  return {
    isAuthenticated,
    user,
    setUser: (user?: UserAuthMe) => {
      if (user) {
        set({ user, isAuthenticated: true });
        return;
      }
      authService.logout();
      // Keep current URL so deep links survive re-login (e.g. /preventivi/125086)
      set({ isAuthenticated: false, user: null });
    },
    loading: false,
    setLoading: (loading) => set({ loading }),
    logout: () => {
      authService.logout();
      set({ user: null, isAuthenticated: false });
    },
  };
});
